<mat-toolbar color="accent">Generate Bridge Download</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <div>{{ progressMessage() }}</div>
    <mat-progress-bar mode="buffer" [value]="progress()" />
  </div>
</mat-dialog-content>

@if (showCloseButton()) {
  <mat-dialog-actions>
    <div class="flex grow"></div>
    <button mat-stroked-button mat-dialog-close>Close</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="downloadDisabled()"
      (click)="download()"
    >
      Download
    </button>
  </mat-dialog-actions>
}
